import manageService from '@app/service/manageService';
import standardService from '@app/service/standardService';
import { create } from 'zustand';
// 전체 기준목록만 공유한다. 동적 상태 조회와 FIRST_REG 경로는 별개다.
let reservationStatusRequest = null;

const initData = {
  nations: [],
  hotelJobTypes: [],
  bankList: [],
  hotelPublicFacilities: [],
  hotelLocations: [],
  hotelServiceTypes: [],
  hotelRoomTypes: [],
  hotelBedItems: [],
  hotelRoomViewItems: [],
  hotelRoomFacilityItems: [],
  hotelRoomsRateGroups: [],
  travelJobTypes: [],
  reservationStatus: [], // 객실 문의 전체 상태
  reservationStatusLoaded: false, // 빈 배열도 성공한 조회 결과다.
  paymentTypes: [], // 결제 방법 기준데이터
};
const globalStore = create((set, get) => ({
  ...initData,
  setNations: () => {
    standardService
      .getNations({ isUsable: true })
      .then((res) => {
        set({ nations: res?.data?.data });
      })
      .catch((e) => console.log(e));
  },
  //호텔 담당자 분류
  setHotelJobTypes: () => {
    if (get().hotelJobTypes?.[0]) return;
    standardService
      .getHotelJobType({ isUsable: true })
      .then((res) => {
        set({ hotelJobTypes: res?.data?.data });
      })
      .catch((e) => console.log(e));
  },
  setBankList: () => {
    standardService
      .getBankList({ isUsable: true })
      .then((res) => {
        set({ bankList: res?.data?.data });
      })
      .catch((e) => console.log(e));
  },
  //호텔 공공 시설
  setHotelPublicFacilities: () => {
    standardService
      .getHotelPublicFacilities({ isUsable: true })
      .then((res) => {
        set({ hotelPublicFacilities: res?.data?.data });
      })
      .catch((e) => console.log(e));
  },
  //호텔 주변 관광지
  setHotelLocations: () => {
    standardService
      .getHotelLocations({ isUsable: true })
      .then((res) => {
        set({ hotelLocations: res?.data?.data });
      })
      .catch((e) => console.log(e));
  },
  //호텔 서비스 종류
  setHotelServiceTypes: () => {
    standardService
      .getHotelServiceTypes({ isUsable: true })
      .then((res) => {
        set({ hotelServiceTypes: res?.data?.data });
      })
      .catch((e) => console.log(e));
  },
  //호텔 객실타입
  setHotelRoomTypes: () => {
    standardService
      .getHotelRoomTypes({ isUsable: true })
      .then((res) => {
        set({ hotelRoomTypes: res?.data?.data });
      })
      .catch((e) => console.log(e));
  },
  //호텔 객실 배드 항목 목록
  setHotelBedItems: () => {
    standardService
      .getHotelBedItems({ isUsable: true })
      .then((res) => {
        set({ hotelBedItems: res?.data?.data });
      })
      .catch((e) => console.log(e));
  },
  //객실 전망 항목 목록
  setHotelRoomViewItems: () => {
    standardService
      .getHotelRoomViewItems({ isUsable: true })
      .then((res) => {
        set({ hotelRoomViewItems: res?.data?.data });
      })
      .catch((e) => console.log(e));
  },
  //객실 내 시설 항목 가져오기
  setHotelRoomFacilityItems: () => {
    standardService
      .getHotelRoomFacilityItems({ isUsable: true })
      .then((res) => {
        set({ hotelRoomFacilityItems: res?.data?.data });
      })
      .catch((e) => console.log(e));
  },
  //호텔 객실 요금 목록 그룹
  setHotelRoomRateGroups: () => {
    standardService
      .getHotelRoomRateGroups({ isUsable: true })
      .then((res) => {
        set({ hotelRoomsRateGroups: res?.data?.data });
      })
      .catch((e) => console.log(e));
  },
  //호텔 객실 매니저 유형
  getTravelJobTypes: () => {
    if (get()?.getHotelJobTypes?.[0]) return;
    standardService
      .getTravelJobTypes({ isUsable: true })
      .then((res) => {
        set({ travelJobTypes: res?.data?.data });
      })
      .catch((e) => console.log(e));
  },
  // 견적/예약 가능한 상태 목록 조회 (기준데이터)
  getReservationStatusList: () => {
    if (get().reservationStatusLoaded || get().reservationStatus.length > 0) return;
    // 액션은 기존처럼 void를 반환한다(effect에서 반환하는 소비자와 호환).
    if (reservationStatusRequest) return;
    const request = manageService
      .getReservationStatusList()
      .then((res) => {
        // 로그아웃/reset 이전 요청이 새 store 상태를 덮어쓰지 않게 한다.
        if (reservationStatusRequest !== request) return;
        const newList = res.data.data.map((data) => {
          return {
            label: data.value,
            value: data.key,
            origin: data,
          };
        });
        set({ reservationStatus: newList, reservationStatusLoaded: true });
      })
      .catch((e) => console.log('e', e))
      .finally(() => {
        // 실패도 해제하여 다음 소비자가 재시도할 수 있게 한다.
        if (reservationStatusRequest === request) reservationStatusRequest = null;
      });
    reservationStatusRequest = request;
  },
  // 결제 방법 기준데이터 가져오기
  getPaymentTypes: () => {
    if (get().paymentTypes.length > 0) return;
    standardService
      .getPaymentTypes()
      .then((res) => {
        const newList = res.data.data.map((data) => {
          return {
            label: data.value,
            value: data.key,
            origin: data,
          };
        });
        set({ paymentTypes: newList });
      })
      .catch((e) => console.log('e', e));
  },
  resetStore: () => {
    reservationStatusRequest = null;
    set(initData);
  },
}));
export default globalStore;
